var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragItem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62326 3.32368C3.11418 3.32368 3.51215 2.92571 3.51215 2.43479C3.51215 1.94387 3.11418 1.5459 2.62326 1.5459C2.13234 1.5459 1.73438 1.94387 1.73438 2.43479C1.73438 2.92571 2.13234 3.32368 2.62326 3.32368Z",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73459 3.32368C10.2255 3.32368 10.6235 2.92571 10.6235 2.43479C10.6235 1.94387 10.2255 1.5459 9.73459 1.5459C9.24367 1.5459 8.8457 1.94387 8.8457 2.43479C8.8457 2.92571 9.24367 3.32368 9.73459 3.32368Z",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62326 10.435C3.11418 10.435 3.51215 10.037 3.51215 9.54612C3.51215 9.0552 3.11418 8.65723 2.62326 8.65723C2.13234 8.65723 1.73438 9.0552 1.73438 9.54612C1.73438 10.037 2.13234 10.435 2.62326 10.435Z",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73459 10.435C10.2255 10.435 10.6235 10.037 10.6235 9.54612C10.6235 9.0552 10.2255 8.65723 9.73459 8.65723C9.24367 8.65723 8.8457 9.0552 8.8457 9.54612C8.8457 10.037 9.24367 10.435 9.73459 10.435Z",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62326 17.5463C3.11418 17.5463 3.51215 17.1484 3.51215 16.6574C3.51215 16.1665 3.11418 15.7686 2.62326 15.7686C2.13234 15.7686 1.73438 16.1665 1.73438 16.6574C1.73438 17.1484 2.13234 17.5463 2.62326 17.5463Z",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73459 17.5463C10.2255 17.5463 10.6235 17.1484 10.6235 16.6574C10.6235 16.1665 10.2255 15.7686 9.73459 15.7686C9.24367 15.7686 8.8457 16.1665 8.8457 16.6574C8.8457 17.1484 9.24367 17.5463 9.73459 17.5463Z",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragItem);
export default __webpack_public_path__ + "static/media/dragItem.cdf4f27bded8c31eec48b7585a5c65fb.svg";
export { ForwardRef as ReactComponent };